import { createRef } from 'react'
import { PAGE_CONST } from '../constant/page-constant'

export const navigationRef = createRef()

export const navigate = (page) => {
  if (navigationRef.current) {
    // navigationRef.current(to)

    switch (page) {
      case PAGE_CONST.LOGIN:
        navigationRef.current('/login')
        break
      case PAGE_CONST.RESET_PASSWORD:
        navigationRef.current('/reset-password')
        break
      case PAGE_CONST.HOME:
        navigationRef.current('/home')
        break
      case PAGE_CONST.SETTINGS:
        navigationRef.current('/settings')
        break
      case PAGE_CONST.SETTINGS_MOBILE_MENU:
        navigationRef.current('/settings-menu')
        break
      case PAGE_CONST.HELP:
        navigationRef.current('/help')
        break
      default:
        navigationRef.current('/login')
    }
  } else {
    console.error('Navigation ref is not set.')
  }
}
